import React from "react";


import { Col, Row } from "react-bootstrap";


import "./index.scss";


type FormContentComponentProps = {
    children?: React.ReactNode | React.ReactNode[];
}


export const FormContentComponent:React.FC<FormContentComponentProps> = ({
    children
}) => {


    return (
        <Col xs={12} className={'form-content-component'}>
            <Row className={'form-content-component__content'}>
                {children}
            </Row>
        </Col>
    );

};


export * from "./FormSection";

export default FormContentComponent;
